import IncidentSection2 from './IncidentSection2';

export default IncidentSection2;
